export default "__VITE_ASSET__DAFpsAQj__"